// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__3kv_J","declined":"ConsentStatus_declined__1dR_2","withdrawn":"ConsentStatus_withdrawn__3V__F"};